import { Check } from 'lucide-react';
import { IDEBadge } from '@/components/shared/extensions';
import type { ExtensionSource } from '@kirin/api-client/contracts/extensions';
import { SourceCell, type SourceType } from '@/components/shared/extensions';
import {
  formatRiskLabel,
  riskLabelSeverity,
} from '@/components/shared/extensions';
import { SeverityBadge } from '@/components/policylist/components/SeverityBadge';

interface FilterOptionProps {
  value: string;
  isSelected: boolean;
}

export function ExtensionSourceFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <div className="flex items-center gap-2">
      {isSelected && <Check className="h-3.5 w-3.5 text-primary shrink-0" />}
      <SourceCell source={value as SourceType} showTooltip={false} />
    </div>
  );
}

export function ExtensionIDEFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <div className="flex items-center gap-2">
      {isSelected && <Check className="h-3.5 w-3.5 text-primary shrink-0" />}
      <IDEBadge sources={[value as ExtensionSource]} />
    </div>
  );
}

/**
 * Risk Estimate multiselect option (KIR-1928): the raw AgentMesh label styled
 * like the table cell (best-effort severity color, neutral for unknown vocab).
 */
export function RiskEstimateFilterOption({
  value,
  isSelected,
}: FilterOptionProps) {
  return (
    <div className="flex items-center gap-2">
      {isSelected && <Check className="h-3.5 w-3.5 text-primary shrink-0" />}
      <SeverityBadge
        riskLevel={riskLabelSeverity(value)}
        label={formatRiskLabel(value)}
        showIcon={false}
      />
    </div>
  );
}
